import React, { useEffect, useState } from "react";

const CLARITY_ID = "tb2jqvew8a";

const loadClarity = () => {
	(function (c: any, l: Document, a: string, r: string, i: string) {
		c[a] =
			c[a] ||
			function () {
				(c[a].q = c[a].q || []).push(arguments);
			};
		const t = l.createElement(r);
		(t as HTMLScriptElement).async = true as any;
		(t as HTMLScriptElement).src = "https://www.clarity.ms/tag/" + i;
		const y = l.getElementsByTagName(r)[0];
		y.parentNode?.insertBefore(t, y);
	})(window as any, document, "clarity", "script", CLARITY_ID);
};

const CookieBanner: React.FC = () => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		try {
			const consent = localStorage.getItem("cookieConsent");
			if (consent === "accepted") {
				// Ensure Clarity is loaded if accepted previously
				if (!(window as any).clarity) {
					loadClarity();
				}
				setVisible(false);
			} else if (consent !== "rejected") {
				setVisible(true);
			}
		} catch (e) {
			setVisible(true);
		}
	}, []);

	const accept = () => {
		localStorage.setItem("cookieConsent", "accepted");
		loadClarity();
		setVisible(false);
	};

	const reject = () => {
		localStorage.setItem("cookieConsent", "rejected");
		setVisible(false);
	};

	if (!visible) return null;

	return (
		<div className="fixed bottom-0 left-0 right-0 z-50">
			<div className="mx-auto max-w-5xl m-4 rounded-lg bg-slate-800/95 text-slate-100 shadow-lg border border-slate-700">
				<div className="p-4 flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
					<p className="text-sm leading-6">
						אנו משתמשים בקובצי Cookie לשיפור חוויית הגלישה, ניתוח שימוש, והצגת
						תוכן רלוונטי. ניתן לשנות החלטה בכל עת בדפדפן. עיון באתר מהווה הסכמה
						למדיניות הפרטיות שלנו.
					</p>
					<div className="flex gap-2 ml-auto">
						<button
							onClick={reject}
							className="px-3 py-2 rounded-md bg-slate-700 hover:bg-slate-600 text-sm"
						>
							דחה
						</button>
						<button
							onClick={accept}
							className="px-3 py-2 rounded-md bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-semibold text-sm"
						>
							מאשר
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CookieBanner;
